import { bundles } from './data/index';
import glossary from '../utils/game/codexGlossary.json';
import { createRulesCatalog } from './catalog';

const catalogs = Object.fromEntries(Object.entries(bundles).map(([code, bundle]) => [code, createRulesCatalog({ ...bundle, baseline: glossary })]));
// Every catalog answers in English when asked for 'en', so any bundle serves
// the source language and an unknown code.
const catalogFor = (language) => catalogs[language] ?? Object.values(catalogs)[0];

export const rulesCatalog = {
  entry: (key, language = 'en') => catalogFor(language).entry(key, language),
  term: (key, language = 'en') => catalogFor(language).term(key, language),
  card: (card, face = 'front', language = 'en') => catalogFor(language).card(card, face, language),
  entries: (query = '', filter = 'all', language = 'en') => catalogFor(language).entries(query, filter, language),
  segments: (text, language = 'en') => catalogFor(language).segments(text, language),
  fresh: (language = 'en') => catalogFor(language).fresh,
};
export const rulesLabel = (text, language = 'en') => (bundles[language] ? (bundles[language].locale.ui[text] ?? rulesCatalog.term(text, language)) : text);
export function localizeTypeLine(text, language) {
  const terms = bundles[language]?.locale.terms;
  if (!terms || !rulesCatalog.fresh(language)) return text;
  const labels = text.split(' ');
  // This field normally contains structured types. Unknown prose must remain
  // intact rather than becoming a mixture of English and German fragments.
  if (!labels.every(word => terms[word])) return text;
  return labels.map(word => rulesCatalog.term(word, language)).join(' · ');
}
